import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnboardfieldsPopupComponent } from './onboardfields-popup.component';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    OnboardfieldsPopupComponent
  ],
   imports: [CommonModule, MatIconModule, ReactiveFormsModule],
})
export class OnboardfieldsPopupModule { }
